module.exports = __webpack_public_path__ + "8d44c68e7908e7ef543635c16ae82ad8.pdf";